import React from 'react';

const SessionLayout = ({ children }) => {
  return <div>{children}</div>;
};

export default SessionLayout;
